import { useTranslation } from 'react-i18next'
import { useAuth } from '@/contexts/AuthContext'
import SidebarLayout from '@/components/common/SidebarLayout'
import UserMenu from '@/components/common/UserMenu'
import SuperProfNoteButton from '@/components/common/SuperProfNoteButton'
import EditModeToggle from '@/components/edit/EditModeToggle'
import {
  Home,
  Video,
  Users,
  UsersRound,
  GraduationCap,
  Star,
  FolderOpen,
  PlayCircle,
  Presentation,
  Mail
} from 'lucide-react'

export default function TeacherLayout() {
  const { t } = useTranslation()
  const { teacher } = useAuth()

  const navigation = [
    { name: t('nav.dashboard'), href: '/teacher/dashboard', icon: Home },
    { name: t('nav.content') || 'Contenido', href: '/teacher/content', icon: FolderOpen },
    { name: t('workshops.title'), href: '/teacher/workshops', icon: Video },
    { name: 'Material talleres', href: '/teacher/workshop-material', icon: Presentation },
    { name: 'Talleres grabados', href: '/teacher/recorded-workshops', icon: PlayCircle },
    { name: t('nav.students') || 'Estudiantes', href: '/teacher/students', icon: Users },
    { name: 'Cohortes', href: '/teacher/cohorts', icon: UsersRound },
    { name: 'Enviar Correo', href: '/teacher/email', icon: Mail },
  ]

  return (
    <SidebarLayout
      navigation={navigation}
      dashboardHref="/teacher/dashboard"
      sidebarBadge={
        <div className="px-4 py-3 border-b">
          <div className="flex items-center gap-2 px-3 py-2 bg-indigo-100 dark:bg-indigo-900/30 rounded-lg">
            <GraduationCap className="w-5 h-5 text-indigo-600 dark:text-indigo-400" />
            <span className="text-sm font-medium text-indigo-600 dark:text-indigo-400">
              {t('roles.teacher') || 'Profesor'}
            </span>
          </div>
        </div>
      }
      sidebarFooter={
        teacher ? (
          <div className="p-4 border-t space-y-3">
            <div className="flex items-center gap-3 text-sm">
              <Star className="w-5 h-5 text-yellow-500" />
              <span>{teacher.rating?.toFixed(1) || '0.0'} ({teacher.total_reviews || 0})</span>
            </div>
            <div className="flex items-center gap-3 text-sm">
              <Users className="w-5 h-5 text-blue-500" />
              <span>{teacher.years_experience || 0} {t('yearsExperience') || 'años exp.'}</span>
            </div>
          </div>
        ) : undefined
      }
      headerActions={
        <>
          {teacher && (
            <div className="flex items-center gap-4 lg:hidden">
              <div className="flex items-center gap-1 text-sm">
                <Star className="w-4 h-4 text-yellow-500" />
                <span>{teacher.rating?.toFixed(1) || '0.0'}</span>
              </div>
            </div>
          )}
          <UserMenu
            avatarClassName="bg-indigo-100"
            iconClassName="text-indigo-600"
            showSettings={false}
            roleBadge={
              <span className="inline-block mt-1 px-2 py-0.5 bg-indigo-100 text-indigo-600 rounded text-xs font-medium">
                {t('roles.teacher') || 'Profesor'}
              </span>
            }
          />
        </>
      }
      floatingElement={<><SuperProfNoteButton /><EditModeToggle /></>}
    />
  )
}
